import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3d2fb0ea&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=3d2fb0ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fb0ea",
  null
  
)

export default component.exports